import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ActivityDateRangeType = 'ytd' | 'last12Months' | 'last3Years' | 'last5Years';

@Injectable({
  providedIn: 'root'
})
export class ItineraryActivitiesDateRangeService {
  private selectedDateRangeSubject = new BehaviorSubject<ActivityDateRangeType>('last12Months');

  selectedDateRange$ = this.selectedDateRangeSubject.asObservable();

  setSelectedDateRange(dateRange: ActivityDateRangeType): void {
    this.selectedDateRangeSubject.next(dateRange);
  }

  getCurrentDateRange(): ActivityDateRangeType {
    return this.selectedDateRangeSubject.value;
  }

  resetToDefault(): void {
    this.selectedDateRangeSubject.next('last12Months');
  }
}
